

















































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import Img from '@/main-components/common/Img.vue';
import { Collection } from '@/resource/collection/collection.model';
import Icon from '@/main-components/common/Icon.vue';
import PaperHeaderEditModal, {
  UpdatePaper,
} from '../common/modal/ModalEditPaper.vue';
import PaperHeaderLoading from './PaperHeaderLoading.vue';
import { OnSubmitReturn } from '@/utils/form/form-input-typing';
import ArrowLink from '../common/ArrowLink.vue';
import truncateString from '@/utils/common/truncate';

@Component({
  components: {
    Img,
    Icon,
    ArrowLink,
    PaperHeaderEditModal,
    PaperHeaderLoading,
  },
})
export default class PaperHeader extends Vue {
  @Prop({ required: true })
  paper: Collection;

  @Prop({ required: true })
  updatePaper: (params: UpdatePaper) => Promise<OnSubmitReturn | null>;

  @Prop({ required: true })
  isPaperLoading: boolean;

  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorBlackPrimary')
  colorBlackPrimary!: string;

  openEditPaperModal: any = null;

  get paperName() {
    return truncateString(`${this.paper.name}`, 60);
  }

  openModalEditPaperAdd(openModal: any) {
    this.openEditPaperModal = openModal;
  }

  editPaperClicked() {
    this.openEditPaperModal && this.openEditPaperModal();
  }
}
